import { IDataWithPaginationCostRevenue, IResultWithPagination } from 'reducers/models';

export interface IETSDetails extends IResultWithPagination<IETSDetail> { }
export interface IUploadLogs extends IDataWithPaginationCostRevenue<IUploadLog> { }

export interface IEquipments {
	equipmentId: number;
	equipmentNumber: string;
	status: string;
	sealNumber: string;
	type: string;
	size: number;
	subType: string;
	subSize: string;
	equipmentTotalVolume: string;
	quantity: string;
	weight: string;
	packages: string;
	documentOnEquipmentVolume: string;
	etOnEssoVolumeFactor: string;
	essoOnEtVolumeFactor: string;
	createDate: string;
	updateDate: string;
}
export interface IEquipments {
	equipmentId: number;
	equipmentNumber: string;
	status: string;
	sealNumber: string;
	type: string;
	size: number;
	subType: string;
	subSize: string;
	equipmentTotalVolume: string;
	quantity: string;
	weight: string;
	packages: string;
	documentOnEquipmentVolume: string;
	etOnEssoVolumeFactor: string;
	essoOnEtVolumeFactor: string;
	createDate: string;
	updateDate: string;
	laneIds?: string[]; // distinct lane ids from the equipment's CLRs
}

/** Booking (SBK) on the ETS shipment, as returned by GET /ets/{id} (shipment.bookings[]). */
export interface IETSBooking {
	bookingId?: number;
	number?: string;
	volume?: number | string;
	primaryIncoterm?: string | null;
	secondaryIncoterm?: string | null;
	laneId?: string | null; // the booking's own lane (GCA)
	clrLaneIds?: string[]; // lane ids of the booking's CLRs (non-GCA)
	pickupLocation?: string | null;
	[key: string]: any;
}
export interface Idocs {
	createdBy: string;
	createdDate: string;
	destinationService: string;
	documentId: number;
	documentNumber: string;
	etd: string;
	finOpsStatus: string;
	originService: string;
	originalDocumentNumber: string;
	packages: number;
	placeOfDeliveryCode: string;
	placeOfDeliveryName: string;
	placeOfReceiptCode: string;
	placeOfReceiptName: string;
	portOfDischargeCode: string;
	portOfDischargeName: string;
	portOfLoadingCode: string;
	portOfLoadingName: string;
	quantity: number;
	shipmentTypeAtDestination: string;
	shipmentTypeAtOrigin: string;
	type: string;
	updatedBy: string;
	updatedDate: string;
	volume: number;
	weight: number;
}
export interface IVoyages {
	voyageId: number;
	voyageNumber: string;
	vesselCode: string;
	vesselName: string;
	loadingPortName: string;
	loadingPortCode: string;
	destinationPortName: string;
	destinationPortCode: string;
	eta: string;
	etd: string;
	ata: string;
	atd: string;
	type: string;
}
export interface ITransportPlanLegVoyage {
	voyageId: number;
	voyageNumber: string;
	vesselCode: string;
	vesselName: string;
	vesselType: string;
	legSequence: number;
}
export interface IETSDetail {
	reopenDate: any;
	equipmentTransportShipmentId: number;
	notificationIndicator: boolean;
	documentNumber: string;
	quantity: string;
	weight: string;
	volume: string;
	packages: string;
	etsOnEtVolumeFactor: string;
	isDeleted: boolean;
	eta: string;
	etd: string;
	createdDate: string;
	updatedDate: string;
	etsFinOpsStatus: string;
	companyCode: string;
	salesAreaRev: string;
	salesOfficeRev: string;
	changeReasonCode: string;
	opsUpdatedDate: string;
	rateErrorMessage?: string;
	lastSORequestSentAt?: string;
	salesDocumentCurrency: string;
	salesDocumentNetValue: number;
	salesDocumentType: string;
	salesOrderNumber: string;
	transportationMode: string;
	originOffice: string;
	destinationOffice: string;
	pricingSource?: number | string;
	cbls: any[];
	equipmentTransport: {
		equipmentTransportId: number;
		equipmentNumber: string;
		sealNumber1: string;
		size: string;
		type: string;
		substitutionType: string;
		substitutionSize: string;
		subType: string;
		shipmentTypeAtOrigin: string;
		shipmentTypeAtDestination: string;
		emptyContainerReturnedCode: string;
		emptyContainerReturnedName: string;
		quantity: number;
		packages: number;
		volume: number;
		weight: number;
		etsOnEtVolumeFactor: number;
		createdDate: string;
		createdBy: string;
		updatedDate: string;
		updatedBy: string;
		primaryIncoterm?: string;
		secondaryIncoterm?: string;
		// Equipment movement moments from the transport plan events; absent until each arrives.
		gateInDate?: string;
		deliveryConfirmedDate?: string;
		gateInEmptyMoveDate?: string;
	};
	shipment: {
		shipmentId: number;
		documentNumber: string;
		placeOfDeconsolidationCode: string;
		placeOfDeconsolidationName: string;
		prepaidCollectIndicator: string;
		placeOfDeliveryCode: string;
		placeOfDeliveryName: string;
		cargoType: string;
		reconsolidationPoint: string;
		consigneeBusinessEntityCode: string;
		consigneeCountryCode: string;
		cosigneeFACTCode: string;
		consigneeName: string;
		placeOfConsolidationCode: string;
		placeOfConsolidationName: string;
		bookingAgent: string;
		bookings: IETSBooking[] | any[];
	};
	voyages: IVoyages[];
	transportPlanLegVoyages?: ITransportPlanLegVoyage[];
	documents: Idocs[];
	equipments: IEquipments[] | any[];
	billingDocuments: any[];
	purchaseOrderNumbers: any[];
	tentativeCloseDate: string;
	isJobClosed: string;
	incoTerm: string;
	specialCargoIndicator: string;
	contractualParty: string;
	contractualPartyRole: string;
	isInvoiceSplitRequired?: boolean; // header-level flag; drives the AnyBookingFlag trigger
}

export const EmptyETSDetails = {
    equipmentTransportShipmentId: 0,
    notificationIndicator: false,
    documentNumber: '',
    quantity: '',
    weight: '',
    volume: '',
    packages: '',
    etsOnEtVolumeFactor: '',
    isDeleted: false,
    eta: '',
    etd: '',
    createdDate: '',
    updatedDate: '',
    etsFinOpsStatus: '',
    companyCode: '',
    salesAreaRev: '',
    salesOfficeRev: '',
    changeReasonCode: '',
    opsUpdatedDate: '',
    rateErrorMessage: '',
    lastSORequestSentAt: '',
    salesDocumentCurrency: '',
    salesDocumentNetValue: 0,
    salesDocumentType: '',
    salesOrderNumber: '',
    transportationMode: '',
    originOffice: '',
    destinationOffice: '',
    cbls: [],
    equipmentTransport: {
        equipmentTransportId: 0,
        equipmentNumber: '',
        sealNumber1: '',
        size: '',
        type: '',
        substitutionType: '',
        substitutionSize: '',
        subType: '',
        shipmentTypeAtOrigin: '',
        shipmentTypeAtDestination: '',
		emptyContainerReturnedCode: '',
    	emptyContainerReturnedName: '',
        quantity: 0,
        packages: 0,
        volume: 0,
        weight: 0,
        etsOnEtVolumeFactor: 0,
        createdDate: '',
        createdBy: '',
        updatedDate: '',
        updatedBy: '',
		primaryIncoterm: '',
		secondaryIncoterm: '',
		gateInDate: '',
		deliveryConfirmedDate: '',
		gateInEmptyMoveDate: ''
    },
    shipment: {
        shipmentId: 0,
        documentNumber: '',
        placeOfDeconsolidationCode: '',
        placeOfDeconsolidationName: '',
        prepaidCollectIndicator: '',
        placeOfDeliveryCode: '',
        placeOfDeliveryName: '',
        cargoType: '',
        reconsolidationPoint: '',
        consigneeBusinessEntityCode: '',
        consigneeCountryCode: '',
        cosigneeFACTCode: '',
        consigneeName: '',
        placeOfConsolidationCode: '',
        placeOfConsolidationName: '',
        bookingAgent: '',
        bookings: []
    },
    voyages: [],
    documents: [],
    equipments: [],
    billingDocuments: [],
    purchaseOrderNumbers: [],
    tentativeCloseDate: '',
    isJobClosed: '',
    reopenDate: '',
	incoTerm: '',
	specialCargoIndicator: '',
	contractualParty: '',
	contractualPartyRole: ''
}

export interface IUploadLog {
   category : string,
   createdBy : string,
   createdDate : string,
   errorLogURl : string,
   id : number,
   modifiedBy : string,
   modifiedDate: string,
   status : string
}
export interface INftpBillableResponse {
    jobId: number;
    isNftpBillable: boolean;
}
